import React, { Fragment } from 'react';
import NumberField from '../../../Base/NumberField';

class Areas extends React.Component {
    render() {
        const { mainDeck, tweenDeck, weatherDeck, total, confirmed } = this.props.areas;
        const { getError, changeField, changeAreas, modifiedFields, underStyle } = this.props;

        return (
            <Fragment>
                <div className='row'>
                    <div className='col-xs-6'>
                        <NumberField
                            floatNumber
                            min={0}
                            fullWidth
                            disabled={confirmed}
                            name='areas.mainDeck'
                            floatingLabelText='Area main deck, m2'
                            value={mainDeck || ''}
                            errorText={getError('areas.mainDeck')}
                            onChange={(e, value) => {
                                changeAreas({ field: 'areas.mainDeck', value });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes('areas.mainDeck') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-6'>
                        <NumberField
                            floatNumber
                            min={0}
                            fullWidth
                            disabled={confirmed}
                            name='areas.tweenDeck'
                            floatingLabelText='Area tween deck, m2'
                            value={tweenDeck || ''}
                            errorText={getError('areas.tweenDeck')}
                            onChange={(e, value) => {
                                changeAreas({ field: 'areas.tweenDeck', value });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes('areas.tweenDeck') ? underStyle : null}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className='col-xs-6'>
                        <NumberField
                            floatNumber
                            min={0}
                            fullWidth
                            disabled={confirmed}
                            name='areas.weatherDeck'
                            floatingLabelText='Area weather deck, m2'
                            value={weatherDeck || ''}
                            errorText={getError('areas.weatherDeck')}
                            onChange={(e, value) => {
                                changeAreas({ field: 'areas.weatherDeck', value });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes('areas.weatherDeck') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-6'>
                        <NumberField
                            name='areas.total'
                            floatingLabelText='Total, m2'
                            value={total || ''}
                            disabled={confirmed}
                            errorText={getError('areas.total')}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'areas.total',
                                    value,
                                    type: 'number',
                                });
                            }}
                            floatNumber
                            min={0}
                            fullWidth
                            underlineStyle={modifiedFields && modifiedFields.includes('areas.total') ? underStyle : null}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default Areas;


// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Areas.jsx